import { Locales } from '@griply/types';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSignupUserMutation } from 'shared/hooks/queries/use-signup-user-mutation';
import { getAppOpenPath } from 'shared/hooks/use-navigate-app-open-screen';

export const useSignup = () => {
  const navigate = useNavigate();
  const { mutateAsync, reset, isPending, error } = useSignupUserMutation();

  const signup = useCallback(
    async ({
      name,
      email,
      password,
      locale,
    }: {
      name?: string;
      email: string;
      password: string;
      locale?: Locales;
    }) => {
      let isSignup: boolean;
      try {
        ({ isSignup } = await mutateAsync({ name, email, password, locale }));
      } catch {
        // the mutation's `error` state carries the form error; the submit handler has no catch
        return;
      }
      navigate(getAppOpenPath({ onboardingPremium: isSignup }));
    },
    [mutateAsync, navigate],
  );

  return { signup, error: error?.kind, retry: reset, isLoading: isPending };
};
